import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { H4FormLabel } from "../../theme/Theme";
import SelectDropDown from "../Custom/SelectDropDown";
import ThemeColor from "../../theme/ThemeColor";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import {
  getDeliveryBoyList,
  createAllocatedDeliveryboy,
} from "../../redux/Thunk/officePickupThunk";
import { roles } from "../../pages/utils/constant";
import { getOfficeList } from "../../redux/Thunk/officeThunk";
import TextArea from "../Custom/TextArea";
import validate from "../../validation/validation";
import DisplayError from "../../validation/DisplayError";

const AllocateDialog = ({
  open,
  onClose,
  onSaveSuccess,
  officeId,
  requestedId,
  fetchAllocated
}) => {
  const [formData, setFormData] = useState({
    Date: null,
    time: null,
    DeliveryBoyId: "",
    OfficeId: "",
    Remark: "",
  });
  const [loader, setLoader] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const todayDate = dayjs();
  const [error, setError] = useState([]);
  const [deliveryBoyList, setDeliveryBoyList] = useState();
  useEffect(() => {
    const fetchDeliveryBoyList = () => {
      dispatch(getDeliveryBoyList({ OfficeId: officeId, page: 1, limit: 100000 }))
        .then((res) => {
          const modeData = res?.payload?.data || [];
          console.log("list", modeData);

          if (modeData.length === 0) {
            console.warn("No branch data available.");
          }

          const mappedMode = modeData.map((item) => ({
            label: item.AdminName,
            value: item.DeliveryBoyId,
          }));

          console.log("ModeTypelist", mappedMode);
          setDeliveryBoyList(mappedMode);
        })
        .catch((error) => {
          console.error("Error fetching modetype list:", error);
        });
    };

    fetchDeliveryBoyList();
  }, [dispatch]);

  let validation_input = [
    {
      tagid: "Date",
      text: formData?.Date ?? "",
      regex_name: "datetime",
      required: true,
      errmsg: "Please Select Allocated Date&Time.",
      min: 1,
      max: 100,
    },
    {
      tagid: "DeliveryBoyId",
      text: formData?.DeliveryBoyId ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Select DeliveryBoyId.",
      min: 1,
      max: 100,
    },
    {
      tagid: "Remark",
      text: formData?.Remark ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Enter Remark",
      min: 1,
      max: 100,
    },
  ];
  const handleSubmit = () => {
    if (validate(validation_input)?.length === 0) {
      setLoader(true);
      const allocatedDetails = {
        Date: dayjs(formData.Date).format("YYYY-MM-DD"),
        Time: dayjs(FormData.Date).format("h:mm A"),
        DeliveryBoyId: formData?.DeliveryBoyId,
        Remark: formData?.Remark,
        RequestedId: requestedId,
        officeId: officeId
      };

      dispatch(createAllocatedDeliveryboy(allocatedDetails))
        .unwrap()
        .then((res) => {
          if (res.success === false) {
            Swal.fire("Error", res.message, "error");
          } else {
            Swal.fire("Success", res.message, "success");
            setFormData({
                 Date: null,
                 time: null,
                 DeliveryBoyId: "",
                 OfficeId: "",
                 Remark: "",
            })
            onSaveSuccess(); 
            fetchAllocated();
          }
        })
        .catch((err) => {
          Swal.fire("Error", err.message || "Something went wrong", "error");
        });
    } else {
      setError(validate(validation_input));
    }
  };

  const handleDateChange = (newValue) => {
    setFormData((prevData) => ({
      ...prevData,
      Date: newValue,
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sweetalert = (variant, text) => {
    Swal.fire({
      icon: variant === "error" ? "error" : "success",
      title: text,
      button: "Ok!",
    });
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Allocate Pickup to Delivery Boy
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Grid container spacing={1}>
          {/* First Row: Date and Time */}
          {/* <Grid container item xs={12} spacing={2}> */}
          <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
              Allocated Date&Time
              <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
            </H4FormLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DateTimePicker
                  name="Date"
                  label="Select Date & Time"
                  value={formData.Date}
                  onChange={handleDateChange}   // Disabled past date
                  sx={{ width: "100%", backgroundColor: "#FFFFFF" }}
                  slotProps={{
                    popper: {
                      sx: {
                        position: "fixed !important",
                        top: "50% !important",
                        left: "50% !important",
                        transform: "translate(-50%, -50%) !important",
                      },
                    }, // Added prop to place the DateTimePicker upwards
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            <DisplayError error={error} fortagid="Date" />
          </Grid>
          {/* </Grid> */}

          {/* Second Row: Allocate To and Remarks */}

          <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
              Allocated to Delivery Boy
              <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
            </H4FormLabel>
            <SelectDropDown
              id="DeliveryBoyId"
              name="DeliveryBoyId"
              placeholder="Select..."
              options={deliveryBoyList}
              value={formData.DeliveryBoyId}
              onChange={handleChange}
              sx={{
                p: 0.1,
                mt: 1,
                pl: 1,
                height: "55px",
                borderRadius: "10px",
                width: "100%",
                backgroundColor: "#FFFFFF",
              }}
            />
            <DisplayError error={error} fortagid="DeliveryBoyId" />
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
            <H4FormLabel
              sx={{ color: ThemeColor.palette.InputTextColor, mb: 0.5 }}
            >
              Remarks
              <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
            </H4FormLabel>
            <TextArea
              id="detailedissue"
              textwidth={"100%"}
              style={{
                width: "95%",
                height: "40px",
                color: ThemeColor.palette.InputTextColor,
                fontFamily: "Inter",
                background: "#FFFFFF",
                border: "1px solid rgba(0, 0, 0, 0.3)",
                // height: "60px",
                borderRadius: "10px",
                fontWeight: 400,
                fontSize: "18px",
                lineHeight: "28px",
                padding: "10px 15px",
              }}
              placeholder="Remark"
              name="Remark"
              value={formData.Remark}
              onChange={handleChange}
            ></TextArea>
            <DisplayError error={error} fortagid="Remark" />
          </Grid>
          {/* </Grid> */}
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
              color: "#FFFFFF",
                  backgroundColor: "#04AB44",
                  "&:hover": { backgroundColor: "#04AB44", color: "#FFFFFF" },
          }}
        >
          Save
        </Button>
        <Button onClick={onClose} sx={{ color: "#1976d2" }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AllocateDialog;
